/* globals PLUG, Shopify, theme, baselThemeModule, nathan_settings, $ */

(function (ToastMessage) {

	"use strict";

	var initialized = false;
	var messageTimer;
	var $container;
	var $message;
	var $closeBtn;

	var hide = function () {
		$container.addClass("hide");
		$container.removeClass("is-visible");
	};

	// Have a new toast message pop up on the screen.
	var push = function (messageText, duration) {
		// Default duration is 2000ms.
		if (duration === undefined) {
			duration = 2000;
		}

		// Clear any previously pushed messages which are still active.
		clearTimeout(messageTimer);
		hide();

		// Set message text.
		$message.text(messageText);

		// Show message.
		$container.removeClass("hide"); // display => block
		setTimeout(function () {
			$container.addClass("is-visible"); // opacity => 1
		}, 50);

		// Set a timer to hide the message after duration ms.
		messageTimer = setTimeout(hide, duration);
	};

	ToastMessage.export = function () {
		if (!initialized) {
			initialized = true;

			$container = $("#PlugToastMessage");
			$message = $container.find(".toast-message__text");
			$closeBtn = $container.find(".toast-message__close-btn");

			$closeBtn.on("click", function () {
				clearTimeout(messageTimer);
				hide();
			});
		}
		return Object.freeze({
			push: push
		});
	};

})(PLUG.ToastMessage = Object.create(null));


(function setupCalculator() {

	"use strict";

/*
Reference / Notes
	Input Methods: length x width, area.
	Product Types: roll, tile, lockTile, tPaver, playsafer.
*/
	var U = PLUG.import("Utils");
	var ToastMessage = PLUG.import("ToastMessage");

	// Constants

	var packSizeOptionNames = ["Tile Quantity", "Select Tile Quantity"];
	var standardOverage = .05;
	var productData;

	// Utility Functions

	var activeVariant = function () {
		var masterSelect = document.getElementsByClassName("main-select")[0];
		console.log(masterSelect)
		var variantId = Number(masterSelect.value);
		var variant = productData.variants.find(function (variant) {
			return variant.id === variantId;
		});
		return variant;
	};

	var convertStringToFeet = function (value) {
	// Takes a string like 12", 12', 12 inches, 12 ft., etc., and returns the number of feet.
		if (value === undefined || value === null) {
			return null;
		}
		var inchesRegex = /inches|in\.|"|''/g;
		var feetRegex = /feet|ft\.|'/g;
		if (value.match(inchesRegex)) {
			value = Number(value.replace(inchesRegex, "").trim());
			return value / 12; // convert to feet
		} else {
			value = value.replace(feetRegex, "").trim();
		}
		return value;
	};

	var formatMoney = function (price) {
		var priceSeparator = price.toString();
		if (priceSeparator.includes('.')) {
			priceSeparator = priceSeparator.split('.');
			priceSeparator[0] = priceSeparator[0].split('').reverse().join('');
			priceSeparator[0] = priceSeparator[0].match(/.{1,3}/g);
			priceSeparator[0] = priceSeparator[0].join(',');
			priceSeparator[0] = priceSeparator[0].split('').reverse().join('');
			priceSeparator = priceSeparator.join('.')
		} else {
			priceSeparator = priceSeparator.split('').reverse().join('');
			priceSeparator = priceSeparator.match(/.{1,3}/g);
			priceSeparator = priceSeparator.join(',');
			priceSeparator = priceSeparator.split('').reverse().join('');
		}

		return PLUG.moneyFormat.replace(/\{\{amount\}\}/, priceSeparator);
	};

	var initPlugCalculator = function (reinit) {
	// Initialize the calculator and all of its components.
	// Called when the DOMContentLoaded event is triggered.
	console.log('initiating plug calculator')
		var productPageWrapper = document.getElementById("second_child_container");
		var variantOptionsTable = productPageWrapper.getElementsByClassName("swatch-options")[0];
		var calculator = document.getElementById("plug-calculator");
		var calculatorMenu = calculator.getElementsByClassName("plug-calculator-menu")[0];
		var addToCartBtn = productPageWrapper.getElementsByClassName("single_add_to_cart_button")[0];
		console.log(addToCartBtn)
		var calculatedPrice = document.getElementById("plug-calculated-price");
		var quantityWrapper = document.getElementById("shopify_quantity");
		var quantityInput = quantityWrapper.querySelector(".qty");
		var quantityBtns = Array.from(quantityWrapper.querySelectorAll(".minus, .plus"));
		productData = JSON.parse(document.getElementById("ProductJsonData").textContent);
		var productType = calculator.getAttribute("data-product-type");
		var hasSubtypes = (productType === "lockTile" || productType === "playsafer" || productType === "mulch");
		var subtypeQuantitiesWr;
		var subtypeQuantityWrappers;
		var subtypeQuantityBtns;
		var subtypeQuantityInputs;
		if (hasSubtypes) {
			subtypeQuantitiesWr = productPageWrapper.getElementsByClassName("plug-calculator-subtype-quantities")[0];
			subtypeQuantityWrappers = Array.from(subtypeQuantitiesWr.getElementsByClassName("subtype-qty-wr"));
			subtypeQuantityBtns = Array.from(subtypeQuantitiesWr.querySelectorAll("input.minus, input.plus"));
			subtypeQuantityInputs = Array.from(subtypeQuantitiesWr.querySelectorAll("input.qty"));
		}


		var setQuantityAndSubmitDisabledState = function (disabled) {
			addToCartBtn.disabled = disabled;
			if (!hasSubtypes) {
				quantityInput.disabled = disabled;
				quantityBtns.forEach(function (btn) {
					btn.disabled = disabled;
				});
			} else {
				subtypeQuantityBtns.concat(subtypeQuantityInputs).forEach(function (ele) {
					ele.disabled = disabled;
				});
			}
		};

		// Determine if the product has a quantity/pack-size variant option,
		// and if so, determine its index.
		var quantityOptionIndex;
		var k = 0;
		while (k < packSizeOptionNames.length) {
			var nameK = packSizeOptionNames[k];
			var index = productData.options.indexOf(nameK);
			if (index !== -1) {
				quantityOptionIndex = index;
				break;
			}
			k += 1;
		}
		var hasQuantityOption = (quantityOptionIndex !== undefined && productType != "playsafer");
		
		// Handles switching to and from the calculator tab.
		var setupTabs = function () {
			// productPageWrapper.setAttribute("data-active-tab", "enter-quantity");
			var quantitySwatchesRow;
			if (hasQuantityOption) {
				quantitySwatchesRow = variantOptionsTable.querySelector("tr[data-option-index='" + quantityOptionIndex + "']");
				
			}
			if (productType === "lockTile") {
				var tileStyleOptionIndex = productData.options.indexOf("Style");
				var tileStyleSwatchesRow = variantOptionsTable.querySelector("tr[data-option-index='" + tileStyleOptionIndex + "']");
			}
			var leastQuantity = 0;
			// We use the following to make sure that if there is a variant option
			// relating to quantity/pack size, the first, and smallest, value is
			// selected before interacting with the calculator.
			var selectLeastQuantityOption = function () {
				if (hasQuantityOption) {
					var activeVariantQuantity = Number(activeVariant().options[quantityOptionIndex]);
					var leastQuantitySwatch;
					if (productType !== "playsafer") {
						// Determine the smallest quantity.
						productData.variants.forEach(function (variant) {
							var quantity = Number(variant.options[quantityOptionIndex]);
							if (!leastQuantity || quantity < leastQuantity) {
								leastQuantity = quantity;
							}
						});
						// If the least quantity option is not selected, select it.
						if (activeVariantQuantity !== leastQuantity) {
							leastQuantitySwatch = quantitySwatchesRow.querySelector(".basel-swatch[data-value='" + leastQuantity + "']");
							if (leastQuantitySwatch) {
								leastQuantitySwatch.click();
							}
						}
					} else {
						// Determine the smallest quantity.
						productData.variants.forEach(function (variant) {
							var quantity = Number(variant.options[quantityOptionIndex].replace(" Tiles", "").replace(" Tile", ""));
							if (typeof quantity === "number" && (!leastQuantity || quantity < leastQuantity)) {
								leastQuantity = quantity;
							}
						});
						
						// If the least quantity option is not selected, select it.
						if (activeVariantQuantity !== leastQuantity) {
							leastQuantitySwatch = quantitySwatchesRow.querySelector(
								".basel-swatch[data-value='" +
									leastQuantity + (leastQuantity === 1 ? "-tile" : "-tiles") +
								"']"
							);
							if (leastQuantitySwatch) {
								leastQuantitySwatch.click();
							}
						}
					}

				}
			};
			// The variant quantity and unit type (e.g. for lockTiles) option should be
			// shown when the enter-quantity tab is active and hidden when the calculator
			// tab is active. This function handles both the showing and hiding depending
			// on the value of the 'visible' boolean.
			var setOptionVisibility = function (visible) {
				if (quantitySwatchesRow) {
					quantitySwatchesRow.style.display = visible ? "" : "none";
				}
				if (tileStyleSwatchesRow) {
					tileStyleSwatchesRow.style.display = visible ? "" : "none";
				}
				// If the quantity option is the last of multiple options, remove the bottom
				// padding from the previous option since we hid the quantity option.
				if (productData.options.length > 1 && quantityOptionIndex === productData.options.length - 1) {
					var lastVisibleSwatchRow = variantOptionsTable.querySelector("tr[data-option-index='" + (quantityOptionIndex - 1) + "']");
					var padding = visible ? "" : "0";
					Array.from(lastVisibleSwatchRow.getElementsByTagName("td")).forEach(function (td) {
						td.style.padding = padding;
					});
				}
			};
			var hideCalculatorMenu = function () {
				if (hasQuantityOption) {
					setOptionVisibility(true);
				}
				calculatorMenu.classList.remove("is-active");
				setQuantityAndSubmitDisabledState(false);
				if (!hasSubtypes) {
					var oldQty = quantityInput.getAttribute("data-old-qty");
					if (oldQty && oldQty !== "") {
						quantityInput.value = quantityInput.getAttribute("data-old-qty");
					}
				}
			};
			var showCalculatorMenu = function () {
				if (hasQuantityOption) {
					selectLeastQuantityOption();
					setOptionVisibility(false);
				}
				var calculatorUsed = productPageWrapper.classList.contains("calculator-used");
				if (!calculatorUsed) {
					setQuantityAndSubmitDisabledState(true);
					calculatedPrice.innerHTML = formatMoney(0);
					if (!hasSubtypes) {
						quantityInput.setAttribute("data-old-qty", quantityInput.value);
						quantityInput.value = "-";
					} else {
						subtypeQuantityInputs.forEach(function (input) {
							input.value = "-";
						});
					}
				}
				calculatorMenu.classList.add("is-active");
			};
			var tabs = Array.from(calculator.getElementsByClassName("plug-calculator__tab"));
			tabs.forEach(function (tab) {
				tab.addEventListener("click", function () {
					console.log("CLICKED")
					if (tab.classList.contains("main")) {
						$('.purchase-details').show();
						$('.description').show();
						$('.shopify-variation-add-to-cart').hide();
						if (productType == "mulch") {
							$('.swatch-options').show();
						}
						if (productType == "playsafer") {
							$('[type="Style"]').show();
							$('.swatch-options').find('.swatch').each(function(){
								if ($(this).attr('type') != "Color" && $(this).attr('type') != "color") {
									console.log($(this).attr('type'))
									$(this).show();
								}
							})
						}
						if (productType == "curb") {
							$('[type="Size"]').show();
							$('[type="Title"]').show();
							$('[type="Select Tile Quantity"]').show();
						}
					} else {
						$('.purchase-details').hide();
						$('.description').hide();
						$('.shopify-variation-add-to-cart').show();
						if (productType == "mulch") {
							$('.swatch-options').hide();
						}
						if (productType == "playsafer") {
							$('[type="Style"]').hide();
							$('.swatch-options').find('.swatch').each(function(){
								if ($(this).attr('type') != "Color" && $(this).attr('type') != "color") {
									$(this).hide();
								}
							});
							var playsafer_option1 = productData.variants[0].option1;
							var option1_id = $('[data-value="' + playsafer_option1 + '"]').find('label').attr('for');
							if ($('#' + option1_id).prop('checked') == false) {
								$('#' + option1_id).click();
							} 
						}
						if (productType == "curb") {
							$('[type="Size"]').hide();
							$('[type="Title"]').hide();
							$('[type="Select Tile Quantity"]').hide();
						}
					}
					if (!tab.classList.contains("is-active")) {
						tabs.forEach(function (tab) {
							tab.classList.remove("is-active");
						});
						tab.classList.add("is-active");
						var tabName = tab.getAttribute("data-tab");
						productPageWrapper.setAttribute("data-active-tab", tabName);
						return (
							tabName === "calculate-quantity"
							? showCalculatorMenu()
							: hideCalculatorMenu()
						);
					}
				});
			});
		};

		var dimensionSelect = document.getElementById("CalcDimensions");
		var lengthInput = document.getElementById("CalcLength");
		var widthInput = document.getElementById("CalcWidth");
		var areaInput = document.getElementById("CalcArea");
		var cubicftInput = document.getElementById("CalcCuft");
		var cubicydInput = document.getElementById("CalcCuyd");
		var linearftInput = document.getElementById("CalcLnft");
		var dimensionInputs = [ lengthInput, widthInput, areaInput, cubicftInput, cubicydInput, linearftInput ];

		var setupDimensionSelect = function () {
			// Set up listeners on the Select Dimensions select.
			var calculatorMenuColumns = Array.from(document.getElementsByClassName("plug-calculator-menu__col"));
			dimensionSelect.addEventListener("change", function () {
				var selectedOption = dimensionSelect.selectedOptions[0];
				var selectedInputMethod = selectedOption.getAttribute("data-input-method");
				console.log(selectedOption);
				console.log(selectedInputMethod);
				calculatorMenuColumns.forEach(function (column) {
					var inputMethod = column.getAttribute("data-input-method");
					if (inputMethod) {
						if (inputMethod === selectedInputMethod) {
							column.classList.remove("hide");
						} else {
							column.classList.add("hide");
						}
						if (selectedInputMethod == "cu-ft" || selectedInputMethod == "cu-yd") {
							$('.plug-calculator-menu__row--fabric .plug-calculator-checkbox').removeClass('is-checked');
							$('.plug-calculator-menu__row--curb .plug-calculator-checkbox').removeClass('is-checked');
							$('.plug-calculator-menu__row--curb').addClass('hide');
							$('.plug-calculator-menu__row--fabric').addClass('hide');
							$('.plug-calculator-menu__input-wr.depth').addClass('hide');
							$('.plug-calculator-menu__row--curb').find('.plug-calculator-checkbox--no-calc').removeClass('is-checked');
							$('.plug-calculator-menu__row--fabric').find('.plug-calculator-checkbox--no-calc').removeClass('is-checked');
							$('.plug-calculator-menu__row.additional-curb').hide();
							$('.plug-calculator-menu__row.additional-wearmat').hide();
							$('.subtype-qty-wr--fabric').hide();
							$('.subtype-qty-wr--curb').hide();
						} else {
							$('.plug-calculator-menu__row--curb').removeClass('hide');
							$('.plug-calculator-menu__row--fabric').removeClass('hide');
							$('.plug-calculator-menu__input-wr.depth').removeClass('hide');
						}
					}
				});
			});
		};

		// Set up listeners to the dimension inputs which set their data-true-value
		// to "" whenever they are changed.
		var setupDimensionInputs = function () {
			dimensionInputs.forEach(function (input) {
				if (input) {
					input.addEventListener("change", function () {
						input.setAttribute("data-true-value", "");
					});
				}
			});
		};

    var setupCheckboxes = function () {
      var checkboxes = Array.from(calculator.getElementsByClassName("plug-calculator-checkbox"));
      checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener("click", function () {
          checkbox.classList.toggle("is-checked");
          calculate();
        });
      });
    };

	var setupCheckboxesMulch = function () {
		$('.plug-calculator-menu__row--fabric .plug-calculator-checkbox--no-calc').click(function(){
			$('.subtype-qty-wr--fabric').toggle();
			if ($(this).hasClass('is-checked')) {
				if (!$('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--fabric').find('input').is(':disabled')) {
					$('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--fabric').find('input').val(0)
				}
				$('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--fabric').find('.subtype-price').html( formatMoney(0))
				$(this).removeClass('is-checked')
			} else {
				$(this).addClass('is-checked')
			}
			calculate();
		})
		$('.plug-calculator-menu__row--curb .plug-calculator-checkbox--no-calc').click(function(){
			$('.subtype-qty-wr--curb').toggle();
			$('.plug-calculator-menu__row.additional-curb').toggle();
			if ($(this).hasClass('is-checked')) {
				$(this).removeClass('is-checked')
				if (!$('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--curb').find('input').is(':disabled')) {
					$('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--curb').find('input').val(0)
				}
				$('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--curb').find('.subtype-price').html( formatMoney(0));
			} else {
				$(this).addClass('is-checked')
			}
			calculate();
		})
		$('.product__curb-type').on('change', 'select', function(){
			var curb_id = $(this).val()
			var curb_default_id;
			var curb_default_price;
			var curb_title;
			var curb_subtitle;
			var curb_unit_length;
			var current_value = $('.subtype-qty-wr--curb').find('input').val();

			$('.product__curb-type').find('option').each(function(){
				if ($(this).attr('value') == curb_id) {
					curb_default_id = $(this).attr('default_variant');
					curb_default_price = $(this).attr('price');
					curb_title = $(this).attr('title').replaceAll('%%', '"');
					curb_subtitle = $(this).attr('subtitle').replaceAll('%%', '"');
					curb_unit_length = convertStringToFeet($(this).attr('default_unit_length'));
					console.log($(this).attr('image'))
					if ($(this).attr('image') != '' && $(this).attr('image') != undefined) {
						$('.subtype-qty-wr--curb').find('img').attr('src', $(this).attr('image'));
					}
				}
			});
			$('.variant-wrapper').each(function(){
				if ($(this).attr('variant') == curb_id) {
					$(this).show();
					$(this).find('.swatch-element').each(function(){
						if ($(this).attr('variant') == curb_default_id) {
							$(this).addClass('selected');
						} else {
							$(this).removeClass('selected');
						}
					});
				} else {
					$(this).hide();
				}
			});
			
			$('.plug-calculator-menu__row--curb').attr('data-unit-length', curb_unit_length);
			$('.subtype-qty-wr--curb').attr('variant', curb_default_id);
			$('.plug-calculator-menu__row--curb').attr('price', curb_default_price)
			$('.subtype-qty-wr--curb').attr('price', curb_default_price / 100)
			$('.subtype-qty-wr--curb').find('.subtype-price').html(formatMoney(parseInt(curb_default_price) * current_value / 100));
			$('.subtype-qty-wr--curb').find('.mulch-qty-label').html(curb_title + " (" + curb_subtitle + ")" );
			calculate();
		});
		$('.swatch-element.curb').click(function(){
			var curb_variant_id = $(this).attr('variant');
			var curb_variant_price = $(this).attr('price');
			var curb_variant_unit_length = $(this).attr('unit_length');
			var current_value = $('.subtype-qty-wr--curb').find('input').val();
			$('.swatch-element.curb').removeClass('selected');
			$(this).addClass('selected')
			$('.plug-calculator-menu__row--curb').attr('data-unit-length', curb_variant_unit_length);
			$('.subtype-qty-wr--curb').attr('variant', curb_variant_id);
			$('.subtype-qty-wr--curb').attr('price', curb_variant_price)
			$('.subtype-qty-wr--curb').find('.subtype-price').html(formatMoney(parseInt(curb_variant_price) * current_value));
			calculate();
		});
		$('.plug-calculator-menu__row--mat').click(function(){
			$('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--mat').find('input').prop("disabled", false);
			$('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--mat').find('input').removeAttr('disabled');
			$('.subtype-qty-wr--mat').toggle();
			$(this).find('.plug-calculator-checkbox--no-calc').toggleClass('is-checked')
			$('.plug-calculator-menu__row.additional-wearmat').toggle();
			var mat_price = $('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--mat').attr('price');
			if ($(this).find('.plug-calculator-checkbox--no-calc').hasClass('is-checked')) { 
				$('.product__wearmat-quantity').find('input').val(1);
				$('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--mat').find('input').val(1);
				$('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--mat').find('.subtype-price').attr('price', (parseInt(mat_price) / 100) * 1)
				$('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--mat').find('.subtype-price').html(formatMoney((parseInt(mat_price) / 100) * 1 ));
			} else {
				$('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--mat').find('.subtype-price').attr('price', 0)
				$('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--mat').find('input').val(0);
			}
			calculate();
		})

		$('.swatch-element.wearmat').click(function(){
			$('.swatch-element.wearmat').removeClass('selected');
			$(this).addClass('selected')
			$('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--mat').find('input').val(1);
			$('.product__wearmat-quantity').find('input').val(1);
			$('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--mat').find('.subtype-price').html(formatMoney(parseInt($(this).attr('price')) / 100));
			$('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--mat').attr('variant', $(this).attr('variant'));
			$('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--mat').attr('price', parseInt($(this).attr('price') / 100));
			$('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--mat').find('.subtype-price').attr('price', parseInt($(this).attr('price')) / 100);
			$('.plug-calculator-menu__row--mat').attr('price', parseInt($(this).attr('price')));
		})

		$('.product__wearmat-quantity').on('change', 'input', function(){
			$('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--mat').find('input').val($(this).val());
			var mat_price = $('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--mat').attr('price')
			$('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--mat').find('.subtype-price').attr('price', (parseInt(mat_price)) * $(this).val())
			$('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--mat').find('.subtype-price').html(formatMoney((parseInt(mat_price)) * $(this).val() ));
			calculate();
		});
		$('.subtype-qty-wr--mat').on('change', 'input', function(){
			$('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--mat').find('input').val($(this).val());
			$('.product__wearmat-quantity').find('input').val($(this).val());
			var mat_price = $('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--mat').attr('price')
			$('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--mat').find('.subtype-price').attr('price', (parseInt(mat_price) / 100) * $(this).val())
			$('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--mat').find('.subtype-price').html(formatMoney((parseInt(mat_price) / 100) * $(this).val() ));
		});

		$('#CalcSize').on('change', function(){
			var size_variant = $(this).val();
			var input_target = $(`label[variant="`+ size_variant +`"]`).attr('for')
			$(`#` + input_target).trigger('click');
		});
	}

		// Set up the calculate button.
		var calculateBtn = document.getElementById("plug-calculate-btn");
		var unitLength = convertStringToFeet(calculator.getAttribute("data-unit-length"));
		var unitWidth = convertStringToFeet(calculator.getAttribute("data-unit-width"));
		var squareFeetPerUnit = (
			productType !== "tPaver"
			? unitLength * unitWidth
			: Number(calculator.getAttribute("data-square-feet-per-unit"))
		);

		// @todo make sure inner tile is selected on tab swap to calc.
		// Based on the active variant, determine the variant associated with each
		// active subtype. Returns an object mapping subtype to the variant.
		var activeLockTileVariants = function () {
			var variant = activeVariant();
			var variants = { tile: variant };
			// Determine the tile type of the active variant.
			var subtypes = ["Tile", "Edge", "Corner"];
			subtypes.forEach(function (subtype) {
				if (variant.options.includes(subtype)) {
					return;
				}
				// Determine which variant has all of the same option values as the
				// active variant, except for its tile type, which is different.
				var variantMatch = productData.variants.find(function (variantK) {
					if (variantK.options.includes(subtype)) {
						return variantK.options.every(function (valueK, i) {
							return (
								valueK === subtype
								|| valueK === variant.options[i]
							);
						});
					} else {
						return false;
					}
				});
				variants[subtype.toLowerCase()] = variantMatch;
			});
			return variants;
		};

		// Based on the active variant, determine the variant associated with each
		// active subtype. Returns an object mapping subtype to the variant.
		var activePlaysaferVariants = function () {
			var variant = activeVariant();
      var activeSubtype; // "border" or "tile"
      var variantTypeOptionIndex;

// Upon creation of this code, the 'type' option did not have values:
// Tile and Border, instead the option values were 1 Tile, 5 Tiles,
// 10 Tiles, 20 Tiles, Edge Piece. That is why the following code
// looks a bit weird, and why quantityOptionIndex was the index we
// used to check tile type.

      if (!quantityOptionIndex) {
        activeSubtype = (
          variant.options.includes("Tile")
          ? "tile"
          : "border"
        );
        var tileIndex = variant.options.indexOf("Tile");
        if (tileIndex === -1) {
          var borderIndex = variant.options.indexOf("Border");
          variantTypeOptionIndex = (
            borderIndex !== -1
            ? borderIndex
            : variant.options.indexOf("Edge Piece")
          );
        } else {
          variantTypeOptionIndex = tileIndex;
        }
      } else {
        activeSubtype = (
          variant.options[quantityOptionIndex] === "Border" || variant.options[quantityOptionIndex] === "Edge Piece"
          ? "border"
          : "tile"
        );
        variantTypeOptionIndex = quantityOptionIndex;
      }

			var variants = Object.create(null);
			variants[activeSubtype] = variant;
			console.log(productData.variants)
			if (activeSubtype === "tile") {
				variants.border = productData.variants.find(function (variantK) {
					var quantityOptionValue = variantK.options[variantTypeOptionIndex].toLowerCase();
					console.log(quantityOptionValue)
					if (quantityOptionValue !== "border" && quantityOptionValue !== "edge piece") {
						return false;
					}
					return variantK.options.every(function (optionValue, i) {
						console.log(i +" : " + optionValue + " : " + variant.options[i]);
						return (
							i === variantTypeOptionIndex
							|| optionValue === variant.options[i]
						);
					});
				});
				if (productType == "playsafer") {
					if (variants.border == undefined) {
						for (let i = 0; i < productData.variants.length; i++) {
							var current_variant_option1 = productData.variants[i].option1.toLowerCase();
							if (current_variant_option1 == "border" || current_variant_option1 == "edge piece") {
								variants.border = productData.variants[i];
								break
							}
						}
					}
				}
			} else {
				variants.tile = productData.variants.find(function (variantK) {
					var quantityOptionValue = variantK.options[variantTypeOptionIndex].toLowerCase();
					console.log(quantityOptionIndex)
					if (quantityOptionValue === "border" || quantityOptionValue === "edge piece") {
						return false;
					}
					return variantK.options.every(function (optionValue, i) {
						return (
							i === variantTypeOptionIndex
							|| optionValue === variant.options[i]
						);
					});
				});
			}
			console.log(variants)
			return variants;
		};

		// Takes quantity data and updates the displayed price.
		var updatePrice = function (quantityData) {
			var variant = activeVariant();
			var price = 0;
			if (!hasSubtypes) {
				price = variant.price * quantityData;
			} else if (productType === "mulch") {

			} else {
				var variants = (
					productType === "lockTile" ? activeLockTileVariants()
					: productType === "playsafer" ? activePlaysaferVariants()
					: null
				);

				Object.keys(variants).forEach(function (subtype) {
					var variant = variants[subtype];
					var quantityWrapper = subtypeQuantityWrappers.find(function (wrapper) {
						return wrapper.getAttribute("data-subtype") === subtype;
					});
					var quantity = Number(quantityWrapper.querySelector(".qty").value);
					if (variant != undefined) {
						price += (variant.price * quantity);
					}
				});
			}
			if (productType === "mulch") {
			} else {
				console.log(price)
				calculatedPrice.innerHTML = "Total: " + formatMoney(price / 100);
			}
		};

		// Listen for quantity inputs so we can adjust the displayed price when
		// they are changed.
		var setupQuantityInputs = function () {
			if (!hasSubtypes) {
				if(productType != "mulch") {
					var getQuantityAndUpdatePrice = function () {
						setTimeout(function () {
							updatePrice(Number(quantityInput.value));
						}, 0);
					};
					quantityInput.addEventListener("change", getQuantityAndUpdatePrice);
					quantityBtns.forEach(function (btn) {
						btn.addEventListener("click", getQuantityAndUpdatePrice);
					});
				}
			} else {
				var quantityData = function () {
					var data = Object.create(null);
					subtypeQuantityWrappers.forEach(function (wrapper) {
						var quantity = Number(wrapper.querySelector(".qty").value);
						var subtype = wrapper.getAttribute("data-subtype");
						data[subtype] = quantity;
					});
					return data;
				};
				if(productType != "mulch") {
					subtypeQuantityWrappers.forEach(function (wrapper) {
						var input = wrapper.querySelector(".qty");
						var btns = Array.from(wrapper.querySelectorAll(".minus, .plus"));
						btns.forEach(function (btn) {
							btn.addEventListener("click", function () {
								setTimeout(function () {
									updatePrice(quantityData());
								}, 0);
							});
						});
						input.addEventListener("change", function () {
							updatePrice(quantityData());
						});
					});
				}
			}
		};

		// Takes a quantity and sets the calculator's quantity value to it.
		// quantityData can be a number or an object.
		var updateQuantity = function (quantityData) {
			if (!hasSubtypes) {
				if (typeof quantityData !== "number") {
					console.log("Quantity must be a number");
					return;
				}
				var quantityInput = document.getElementById("shopify_quantity").querySelector(".qty");
				quantityInput.value = quantityData;
			} else if (productType === "mulch") {
				var mulch_variants = $('.subtype-qty-wr.subtype-qty-wr--mulch');
				var variant = activeVariant();
				for (let i = 0; i < mulch_variants.length; i++) {
					var mulch_variant_id = $(mulch_variants[i]).attr('variant')
					// if (parseInt(mulch_variant_id) === parseInt(variant.id)) {
						// $(mulch_variants[i]).find('input').val(quantityData)
						// $(mulch_variants[i]).find('.subtype-price').html(formatMoney((variant.price / 100) * quantityData));
						// $(mulch_variants[i]).find('.subtype-price').attr("price",(variant.price / 100) * quantityData)
					// } else {
					// 	if ($(mulch_variants[i]).hasClass('subtype-qty-wr--fabric') && $('.plug-calculator-menu__row--fabric .plug-calculator-checkbox').hasClass('is-checked')) {
					// 	} else if ($(mulch_variants[i]).hasClass('subtype-qty-wr--curb') && $('.plug-calculator-menu__row--curb .plug-calculator-checkbox').hasClass('is-checked')) {
					// 	} else {
					// 		if (!$(mulch_variants[i]).hasClass('subtype-qty-wr--mat')) {
					// 			$(mulch_variants[i]).find('input').val(0)
					// 			$(mulch_variants[i]).find('.subtype-price').html(formatMoney(0));
					// 		}
					// 	}

					// }
					$(mulch_variants[i]).on('change','input', function(){
						var parent = $(this).parents('.subtype-qty-wr--mulch');
						var price_change = parseInt(parent.attr('price')) * $(this).val();
						parent.find('.subtype-price').html(formatMoney(price_change / 100));
						parent.find('.subtype-price').attr("price", price_change / 100);
						var total_price = 0;
						var mulch_variants = $('.subtype-qty-wr.subtype-qty-wr--mulch');
						for (let i = 0; i < mulch_variants.length; i++) {
							if ($(mulch_variants[i]).find('.subtype-price').attr('price') != undefined) {
								if ($(mulch_variants[i]).hasClass('subtype-qty-wr--fabric')) {
									console.log($('.plug-calculator-menu__row--fabric').find('.plug-calculator-checkbox--no-calc'))
									if ($('.plug-calculator-menu__row--fabric').find('.plug-calculator-checkbox--no-calc').hasClass('is-checked')) {
										total_price = total_price + parseInt($(mulch_variants[i]).find('.subtype-price').attr('price'));
									}
								} else if($(mulch_variants[i]).hasClass('subtype-qty-wr--curb')) {
									if ($('.plug-calculator-menu__row--curb').find('.plug-calculator-checkbox--no-calc').hasClass('is-checked')) {
										total_price = total_price + parseInt($(mulch_variants[i]).find('.subtype-price').attr('price'));
									}
								} else {
									total_price = total_price + parseInt($(mulch_variants[i]).find('.subtype-price').attr('price'));
								}
							}
						}
						$('#plug-calculated-price').html("Total: " + formatMoney(total_price));
					});
				}
			} else {
				if (typeof quantityData !== "object") {
					console.log("Error: quantityData must be an object.");
					return;
				}
				subtypeQuantityWrappers.forEach(function (wrapper) {
					var subtype = wrapper.getAttribute("data-subtype");
					var input = wrapper.querySelector(".qty");
					input.value = quantityData[subtype];
				});
			}
		};

		var results = calculator.querySelector("[data-results]");
		var results1 = calculator.querySelector(".plug-calculator-menu__results-1 .plug-calculator-menu__results-value");
		var results2 = calculator.querySelector(".plug-calculator-menu__results-2 .plug-calculator-menu__results-value");

		var performCalculateAnimation = function (cb) {
			U.setButtonLoadingState(calculateBtn, true);

			if (!hasSubtypes) {
				results.classList.remove("is-active");
			} else if (productType === "lockTile") {
				results1.classList.remove("is-active");
				var individualResults = Array.from(document.getElementsByClassName("plug-calculator-lock-tile-results"));
				individualResults.forEach(function (resultWr) {
					var valueEle = resultWr.querySelector(".plug-calculator-menu__results-value");
					valueEle.classList.remove("is-active");
				});
			} else if (productType === "playsafer") {
				results1.classList.remove("is-active");
				results2.classList.remove("is-active");
			}

			setTimeout(function () {
				U.setButtonLoadingState(calculateBtn, false);
				calculateBtn.querySelector("[data-button-content]").textContent = "RE-CALCULATE";
				cb();
				if (!hasSubtypes) {
					results.classList.add("is-active");
				} else if (productType === "lockTile") {
					results1.classList.add("is-active");
					var individualResults = Array.from(document.getElementsByClassName("plug-calculator-lock-tile-results"));
					individualResults.forEach(function (resultWr) {
						var valueEle = resultWr.querySelector(".plug-calculator-menu__results-value");
						valueEle.classList.add("is-active");
					});
				} else if (productType === "playsafer") {
					results1.classList.add("is-active");
					results2.classList.add("is-active");
				}

			}, 400);
		};

		var updateResults = function (quantityData) {
			performCalculateAnimation(function () {
				if (!productPageWrapper.classList.contains("calculator-used")) {
					productPageWrapper.classList.add("calculator-used");
					setQuantityAndSubmitDisabledState(false);
				}
				updateQuantity(quantityData);
				updatePrice(quantityData);
				if (productType == "mulch") {	
					var mulch_variants = $('.subtype-qty-wr.subtype-qty-wr--mulch');
					var total_price = 0;
					for (let i = 0; i < mulch_variants.length; i++) {
						if ($(mulch_variants[i]).find('.subtype-price').attr('price') != undefined) {
							if ($(mulch_variants[i]).hasClass('subtype-qty-wr--fabric')) {
								if ($('.plug-calculator-menu__row--fabric').find('.plug-calculator-checkbox--no-calc').hasClass('is-checked')) {
									total_price = total_price + parseInt($(mulch_variants[i]).find('.subtype-price').attr('price'));
								}
							} else if($(mulch_variants[i]).hasClass('subtype-qty-wr--curb')) {
								if ($('.plug-calculator-menu__row--curb').find('.plug-calculator-checkbox--no-calc').hasClass('is-checked')) {
									total_price = total_price + parseInt($(mulch_variants[i]).find('.subtype-price').attr('price'));
								}
							} else {
								total_price = total_price + parseInt($(mulch_variants[i]).find('.subtype-price').attr('price'));
							}
							
						}
					}
					$("#plug-calculated-price").html("Total: " + formatMoney(total_price));
				}
				if (!hasSubtypes) {
					var display_result
					if (productType == "tPaver") {
						var pack = calculator.getAttribute('data-pack');
						if (pack != undefined) {
							quantityData = Math.ceil(quantityData * parseInt(pack));
						}
					}
					display_result = parseInt(quantityData).toString();
					display_result = display_result.split('').reverse().join('');
					display_result = display_result.match(/.{1,3}/g);
					display_result = display_result.join(',');
					display_result = display_result.split('').reverse().join('');
					results.textContent = display_result;
					if (productType == "tPaver") {
						var pack = calculator.getAttribute('data-pack');
						if (pack != undefined) {
							quantityData = Math.ceil(quantityData / parseInt(pack));
						}
					}
				} else if (productType === "lockTile") {
					results1.textContent = quantityData.tile + quantityData.edge + quantityData.corner;
					var individualResults = Array.from(document.getElementsByClassName("plug-calculator-lock-tile-results"));
					individualResults.forEach(function (resultWr) {
						var tileType = resultWr.getAttribute("data-subtype");
						var valueEle = resultWr.querySelector(".plug-calculator-menu__results-value");
						valueEle.textContent = quantityData[tileType];
					});
				} else if (productType === "playsafer") {
					var display_tile = parseInt(quantityData.tile).toString();
					display_tile = display_tile.split('').reverse().join('');
					display_tile = display_tile.match(/.{1,3}/g);
					display_tile = display_tile.join(',');
					display_tile = display_tile.split('').reverse().join('');

					if (quantityData.border != undefined && quantityData.border != NaN) {
						var display_border = parseInt(quantityData.border).toString();
						display_border = display_border.split('').reverse().join('');
						display_border = display_border.match(/.{1,3}/g);
						display_border = display_border.join(',');
						display_border = display_border.split('').reverse().join('');
					}

					results1.textContent = display_tile;
					results2.textContent = display_border;
				} 
			});
		};

    // Takes an inputMethod and a data object, and returns the area.
    var area = function (inputMethod, data) {
      return (
        inputMethod === "length x width" ? data.length * data.width
        : inputMethod === "area" ? data.area
        : null
      );
    };

    // Takes an areaToCover and an areaPerUnit, and returns the minimum number
    // of units required to cover areaToCover. Overage defaults to 0, but a
    // decimal like (.05) can be passed in to add some padding to our results.
    var calcUnitQuantity = function (areaToCover, areaPerUnit, overage) {
      if (overage === undefined) {
        overage = 0;
      }
	  console.log("test area")
	  console.log(areaPerUnit);
      return Math.round(Math.ceil((areaToCover / areaPerUnit)) * (1 + overage));
    };

		// Used for rolls, tiles, and tPavers.
		var calculateQuantity = function (inputMethod, data, overage) {
			return calcUnitQuantity(
				area(inputMethod, data),
				squareFeetPerUnit,
				overage
			);
		};

		var calculateQuantityCurb = function (inputMethod,data) {
			console.log("Curb test calculate")
			var areaToCover = area(inputMethod, data);
			var perimeter;
			var curblength = "empty";
			var curb_variant = activeVariant();
			if ($('.variant-length').length > 0) {
				$('.variant-length').each(function(){
					if ($(this).attr('variant') == curb_variant.id) {
						curblength = $(this).attr('unit_length');
					}
				});
				if (curblength == "empty") {
					curblength = unitLength;
				}
			} else {
				curblength = unitLength;
			}
			console.log("use length: " + curblength)
			if ( typeof curblength == "string") {
				console.log("string");
				curblength = convertStringToFeet(curblength);
			} else {
				console.log("integer")
			}

			console.log(curblength)
			if (inputMethod === "area") {
				perimeter = (Math.sqrt(areaToCover) * 4);
			} else if (inputMethod === "linear-ft") {
				console.log(data)
				perimeter = data.linearft;
			}	else {
				perimeter = (2 * data.length) + (2 * data.width);
			}
			return Math.ceil(perimeter / curblength);
		}
		var calculateQuantityMulch = function (inputMethod,data) {
			var mulch_variants = $(document).find('label.mulch');
			var matched_variant;
			console.log(mulch_variants)
			for (let i = 0; i < mulch_variants.length; i++) {
				var mulch_variant_id = $(mulch_variants[i]).find('h4').attr('variant')
				if (parseInt(mulch_variant_id) === parseInt(activeVariant().id)) {
					matched_variant = mulch_variants[i];
				}
			}
			var variant_volume = $(matched_variant).find('p.product__mulch-volume').attr('volume');
			var variant_weight = $(matched_variant).find('h4').attr('weight');
			var depth = convertStringToFeet($('#depth').val())
			var poundsUnit = parseInt(variant_weight) / parseInt(variant_volume);
			var req_pound 
			if (inputMethod === "cu-ft") {	
				req_pound = parseInt(data.cuft) * poundsUnit;
			} else if (inputMethod === "cu-yd") {
				req_pound = (parseInt(data.cuyd) * 27) * poundsUnit;
			} else {
				req_pound = (area(inputMethod,data) * depth) * poundsUnit;
			}
			

			var display_pound = (req_pound.toFixed(0)).toString();
			if (display_pound.includes('.')) {
				display_pound = display_pound.split('.');
				display_pound[0] = display_pound[0].split('').reverse().join('');
				display_pound[0] = display_pound[0].match(/.{1,3}/g);
				display_pound[0] = display_pound[0].join(',');
				display_pound[0] = display_pound[0].split('').reverse().join('');
				display_pound = display_pound.join('.')
			} else {
				display_pound = display_pound.split('').reverse().join('');
				display_pound = display_pound.match(/.{1,3}/g);
				display_pound = display_pound.join(',');
				display_pound = display_pound.split('').reverse().join('');
			}
			

			results.textContent = display_pound + ' lbs.';
			results.classList.add('is-active');
			if (req_pound > 960) {
				if ((req_pound / 1000) > 0.9) {
					req_pound = Math.round( (parseInt(req_pound)) / 1000, 1) * 1000;
				} else if ((req_pound / 100) > 0.9) {
					req_pound = Math.round( (parseInt(req_pound)) / 100, 1) * 100;
				}  else if ((req_pound / 10) > 0.9) {
					req_pound = Math.round( (parseInt(req_pound)) / 10, 1) * 10;
				} else {
					req_pound = Math.round( (parseInt(req_pound)) , 1);
				}
			}

			var allweight = [];
			var distributed_qty = [];
			$('.subtype-qty-wr--mulch').each(function(){
				if ($(this).attr('weight') != undefined) {
					if (req_pound > 960) {
						if (Number($(this).attr('weight')) > 401) {
							allweight.push(Number($(this).attr('weight')));
							distributed_qty.push(0);
							$(this).show();
						} else {
							$(this).hide();
						}
					} else {
						if (Number($(this).attr('weight')) < 401) {
							allweight.push(Number($(this).attr('weight')));
							distributed_qty.push(0);
							$(this).show();
						} else {
							$(this).hide();
						}
					}

				}
			});
			allweight.sort((a, b) => b - a)
			var remainder = 0;
			var initial_divide = true;
			for (let i = 0; i < allweight.length; i ++ ) {
				if (initial_divide) {
					console.log(allweight[i] + " : " + req_pound)
					if (allweight[i] <= req_pound) {
						distributed_qty[i] = Math.floor(req_pound / allweight[i]);
						remainder = parseFloat(req_pound) % parseFloat(allweight[i]);
						initial_divide = false;
					}
					if (i == (allweight.length - 1) && initial_divide) {
						distributed_qty[i] = 1;
						initial_divide = false;
					}
				} else {
					console.log(allweight[i] + " : " + remainder)
					if (allweight[i] <= remainder) {
						distributed_qty[i] = Math.floor(remainder / allweight[i]);
						remainder = remainder % allweight[i];
						if (i == allweight.length - 1 && remainder > 0) {
							distributed_qty[i] = distributed_qty[i] + 1;
						}
					}
				}
			}
			console.log(allweight)
			$('.subtype-qty-wr--mulch:not(.subtype-qty-wr--mat)').each(function(){
				$(this).hide();
				$(this).find('input').val(0)
				for (let i = 0; i < allweight.length; i ++ ) {
					if ($(this).attr('weight') == allweight[i]) {
						var variant_price = $(this).attr('price')
						$(this).find('input').val(distributed_qty[i])
						$(this).find('.subtype-price').html(formatMoney((variant_price / 100) * distributed_qty[i]));
						$(this).find('.subtype-price').attr("price",(variant_price / 100) * distributed_qty[i]);
						$(this).show();
					}
				}
			});
			// Calculate Additional Fabric
			if ($('.plug-calculator-menu__row--fabric .plug-calculator-checkbox--no-calc').hasClass('is-checked')) {
				console.log("calculate fabric")
				var fabric_length = convertStringToFeet($('.plug-calculator-menu__row--fabric').attr('data-unit-length'));
				var fabric_width = convertStringToFeet($('.plug-calculator-menu__row--fabric').attr('data-unit-width'));
				var fabricAreaPerUnit = fabric_length * fabric_width;
				var req_fabric = calcUnitQuantity(area(inputMethod, data),fabricAreaPerUnit,0);
				var fabric_price = parseInt($('.plug-calculator-menu__row--fabric').attr('price'));
				$('.subtype-qty-wr--fabric input').val(req_fabric);
				$('.subtype-qty-wr--fabric .subtype-price').html(formatMoney(req_fabric * fabric_price / 100))
				$('.subtype-qty-wr--fabric .subtype-price').attr('price', req_fabric * fabric_price / 100)
				$('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--fabric').show();
			}
			// Calculate Additional Border
			if ($('.plug-calculator-menu__row--curb .plug-calculator-checkbox--no-calc').hasClass('is-checked')) {
				var areaToCover = area(inputMethod, data);
				var perimeter;
				if (inputMethod === "area") {
					perimeter = (Math.sqrt(areaToCover) * 4);
				} else {
					perimeter = (2 * data.length) + (2 * data.width);
				}
				var curb_length = convertStringToFeet($('.plug-calculator-menu__row--curb').attr('data-unit-length'))
				perimeter = Math.ceil(perimeter / curb_length);
				var curb_price = parseInt($('.plug-calculator-menu__row--curb').attr('price'));
				console.log(curb_price)
				$('.subtype-qty-wr--curb input').val(perimeter);
				$('.subtype-qty-wr--curb .subtype-price').html(formatMoney(perimeter * curb_price / 100))
				$('.subtype-qty-wr--curb .subtype-price').attr('price', perimeter * curb_price / 100)
				$('.subtype-qty-wr.subtype-qty-wr--mulch.subtype-qty-wr--curb').show();
			}

			return Math.ceil(req_pound / variant_weight);

		}

    var overageBtn = document.getElementById("plug-overage-btn");
    var includeBordersBtn = document.getElementById("plug-calculate-borders-btn");

		var quantityCalculators = {
			roll: calculateQuantity,
			tile: calculateQuantity,
			tPaver: calculateQuantity,
			mulch: calculateQuantityMulch,
			curb: calculateQuantityCurb,
			lockTile: function (ignore, data, overage) {
				var rawNumWidthTiles = data.width / unitWidth;
				var rawNumLengthTiles = data.length / unitLength;

// We must determine the number of tiles per row and column. The client would like
// these numbers to round down if the decimal is less than .3, and round up otherwise.

        var numWidthTiles = (
          (rawNumWidthTiles % 1) < .3
          ? Math.floor(rawNumWidthTiles)
          : Math.ceil(rawNumWidthTiles)
        );
        var numLengthTiles = (
          (rawNumLengthTiles % 1) < .3
          ? Math.floor(rawNumLengthTiles)
          : Math.ceil(rawNumLengthTiles)
        );

				var numWidthEdgeTiles = numWidthTiles - 2;
				var numLengthEdgeTiles = numLengthTiles - 2;
				return {
					corner: 4, // Rectangular shape is assumed, so there must be 4 corner tiles.
					border: Math.round(
            (2 * numLengthEdgeTiles) + (2 * numWidthEdgeTiles) * (overage + 1)
          ),
					tile: Math.round(
            numLengthEdgeTiles * numWidthEdgeTiles * (overage + 1)
          )
				};
			},
			playsafer: function (ignore, data, overage) {
		var area = data.length * data.width;
		if (data.length == undefined || data.length == NaN || data.width == undefined || data.width == NaN ) {
			area = areaInput.value;
			console.log(area)
			data.length = Math.sqrt(area);
			console.log(data.length)
			data.width = Math.sqrt(area);
		}

        var includeBorders = includeBordersBtn.classList.contains("is-checked");
        var numTiles = calcUnitQuantity(area, squareFeetPerUnit, overage);
        var numBorders;

		// The client does not want the border pieces to be factored into the area to cover.

        if (includeBorders) {
          var borderWidth = convertStringToFeet(calculator.getAttribute("data-border-unit-width"));
          var borderLength = convertStringToFeet(calculator.getAttribute("data-border-unit-length"));
          var totalArea = (data.length + 2*borderWidth) * (data.width + 2*borderWidth);
          var borderArea = totalArea - area;
          numBorders = calcUnitQuantity(
            borderArea,
            borderWidth * borderLength,
            overage
          );
        }

				return {
					tile: numTiles,
					border: numBorders
				};
			}
		};

		var calculate = function () {
			var selectedOption = dimensionSelect.selectedOptions[0];
			var inputMethod = selectedOption.getAttribute("data-input-method");
			var overage = overageBtn.classList.contains("is-checked") ? standardOverage : 0;
			// Create our data object, which should contain all input data
			// needed for our calculations.
			var data = Object.create(null);
			if (inputMethod === "length x width") {
				if (lengthInput.value === "" || widthInput.value === "") {
					throw new Error("Both a length and a width are required.");
				}
				data.length = Number(lengthInput.value);
				data.width = Number(widthInput.value);
			} else if (inputMethod === "area") {
				if (areaInput.value === "") {
					throw new Error("Must provide an area value.");
				}
				data.area = Number(areaInput.value);
			} else if (inputMethod == "cu-ft") {
				if (cubicftInput.value === "") {
					throw new Error("Must provide a ft value.");
				}
				data.cuft = Number(cubicftInput.value);
			 }else if (inputMethod == "cu-yd") {
				if (cubicydInput.value === "") {
					throw new Error("Must provide an yard value.");
				}
				data.cuyd = Number(cubicydInput.value);
			} else if (inputMethod == "linear-ft") {
				if (linearftInput.value === "") {
					throw new Error("Must provide an Linear ft value.");
				}
				data.linearft = Number(linearftInput.value);
			}
			var quantityData = quantityCalculators[productType](inputMethod, data, overage);
			// console.log(quantityData)
			if (productType == "tPaver") {
				var pack = calculator.getAttribute('data-pack');
				if (pack != undefined) {
					quantityData = Math.ceil(quantityData / parseInt(pack));
				}
			}
			updateResults(quantityData);
		};

		var setupCalculateBtn = function () {
			calculateBtn.addEventListener("click", calculate);
			if ($('#second_child_container').hasClass('calculator-used')) {
				console.log("calculate again")
				calculate();
			}
		};

		var setupAddToCartBtn = function () {
			// if (!hasSubtypes) {
			// 	return;
			// }
			console.log("setup")
			// $('#shopify_add_to_cart').click(function(){
			// 	console.log("clicked")
			// })
			addToCartBtn.addEventListener("click", function (e) {
				console.log("TEST")
				// if (productPageWrapper.getAttribute("data-active-tab") !== "calculate-quantity") {
				// 	return;
				// }
				e.preventDefault();
				e.stopImmediatePropagation();
				console.log('click')
				// U.setButtonLoadingState(addToCartBtn, true);
				// addToCartBtn.disabled = true;
				// addToCartBtn.style.pointerEvents = "none";
				// addToCartBtn.classList.add("loading");
				// Get the variant ID of each tile type to be added.
				var items = [];
				var activeVariants = (
					productType === "lockTile" ? activeLockTileVariants()
					: productType === "playsafer" ? activePlaysaferVariants()
					: null
				);
				var $addToCartForm = $(this).closest('form');
				var add_data;
				if (hasSubtypes && productType != "mulch") {
					console.log(activeVariants)
					console.log(hasSubtypes)
					Object.keys(activeVariants).forEach(function (subtype) {
						var variant = activeVariants[subtype];
						console.log(variant)
						var quantityWrapper = subtypeQuantityWrappers.find(function (wrapper) {
							return wrapper.getAttribute("data-subtype") === subtype;
						});
						if (variant != undefined) {
							items.push({
								id: variant.id,
								quantity: Number(quantityWrapper.querySelector(".qty").value)
							});
						}
					});
					add_data = { items: items}
				} else if (productType == "mulch") {
					$('.subtype-qty-wr.subtype-qty-wr--mulch').each(function(){
						var variant_id = parseInt($(this).attr('variant'));
						var variant_quantity = $(this).find('input').val();
						items.push({
							id: variant_id,
							quantity: Number(variant_quantity)
						});
					})
				} else {
					var item_id = activeVariant().id;
					var item_quantity = Number(quantityWrapper.querySelector(".qty").value);
					items.push({
						id: item_id,
						quantity: item_quantity
					});
				}
				console.log(items)
				var addbtn = $('.single_add_to_cart_button');
				$.ajax({
					url: '/cart/add.js',
					type: 'post',
					cache: false,
					data: {items: items},
					beforeSend: function() {
						addbtn.attr('disabled', 'disabled').addClass('disabled');
						addbtn.find('span').removeClass("zoomIn").addClass('animated zoomOut');
					},
					success: function(itemData) {
                      	var outOfStockMessage = document.getElementById("out-of-stock-message");
                      	if (outOfStockMessage) {
                      		outOfStockMessage.classList.add("hide");
                      	}
						addbtn.find('span').removeClass('zoomOut').addClass('fadeIn');
						addbtn.find('span.text').text(Shopify.translation.product_add_to_cart_success)
						window.setTimeout(function(){
						addbtn.removeAttr('disabled').removeClass('disabled');
						addbtn.find('span.text').text(addbtn.attr('data-label'))
						addbtn.find('span').addClass("fadeOut").removeClass('fadeIn').removeClass("fadeOut").addClass('zoomIn');
						}, 1000);
			
						$.ajax({
						url: '/cart.js',
						dataType: "json",
						cache: false,
						success: function(cart) {
							refreshCart(cart);
							window.setTimeout(function(){ $.fancybox.close(); $('.cart-button').click(); }, 500);
						}
						});
					},
					error: function(XMLHttpRequest) {
                      	var respJson = JSON.parse(XMLHttpRequest.responseText);
                      	console.log(respJson);
                      	var desc;
                      	var outOfStockMessage = document.getElementById("out-of-stock-message");
                        if (outOfStockMessage) {
                            if (respJson.description.includes("is already sold out")) {
                                desc = respJson.description.replace("The product '", "").replace("' is already sold out.", "").replace(productData.title, "").replace(" - ", "");
                                outOfStockMessage.textContent = desc + " is out of stock.";
                                outOfStockMessage.classList.remove("hide");
                                console.log(desc);
                            } else if (respJson.description.includes("You can only add ")) {
                                desc = respJson.description.replace("You can only add ", "").replace(" to the cart.", "").replace(productData.title, "").replace(" - ", "");
                                outOfStockMessage.textContent = "Only " + desc + " in stock.";
                                outOfStockMessage.classList.remove("hide");
                                console.log(desc);
                            }
                        }
						var response = eval('(' + XMLHttpRequest.responseText + ')');
						response = response.description;
						$('.warning').remove();
			
						var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
						$addToCartForm.after(warning);
						addbtn.removeAttr('disabled').removeClass('disabled');
						addbtn.find('span.text').text(Shopify.translation.product_add_to_cart)
						addbtn.find('span').removeClass('zoomOut').addClass('zoomIn');
					}
					});
			
			}, false);
		};

		// Init
		setupTabs();
		setupDimensionSelect();
		setupDimensionInputs();
		setupCheckboxes();
		setupCheckboxesMulch();
		setupQuantityInputs();
		setupCalculateBtn();
		setupAddToCartBtn();
	};
    function initcolorselect() {
        console.log("INIT COLOR SELECT");
        console.log($('.plug-calculator-template__colors'));
        $('.plug-calculator-template__colors').on('click','.product-select', function(){
            console.log("click");
			$(this).addClass('selected');
			$(this).siblings().removeClass('selected');
            var handle = $(this).attr('handle');
            var ajax = jQuery.ajax({
                url: '/products/' + handle + '?view=calculator-ajax', 
                cache: false,
                success: function(response) {
					var current_form = $('.plug-calculator-template__wrapper').find('.product_form');
					var current_additionals = $('.plug-calculator-template__wrapper').find('.plug-calculator__additionals');
					var current_variations = $('.plug-calculator-template__wrapper').find('.plug-variation__container')
					$('.temporary').empty();
					$('.temporary').append(response);
					var productdata = $('.temporary').find('#ProductJsonDataAjax');
					$('#ProductJsonData').empty();
					console.log(productdata)
					$('#ProductJsonData').append(productdata.text())
					current_form.empty();
					current_form.append($('.temporary').find('.product_form').children())
					current_additionals.empty();
					current_additionals.append($('.temporary').find('.plug-calculator__additionals').children());
					current_variations.empty();
					current_variations.append($('.temporary').find('.plug-variation__container').children());
					$('#plug-calculate-btn').off();
					
					initPlugCalculator();
                },
                error: function(error) {
                }
            });
        });
    }
	window.addEventListener("DOMContentLoaded", initPlugCalculator);
    if(document.readyState !== 'loading') {
        initcolorselect();
    } else {
        window.addEventListener('DOMContentLoaded', function () {
            
        })
    }
})();
